module.exports = __webpack_public_path__ + "img/notice5.078a7dbb.png";